import { useSearchParams, Link, useLocation } from 'react-router-dom';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import TermGuidelineCategory from '@/components/TermGuidelineCategory';

const QualityGuidelineUnopenedPackPage = () => {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const isMobile = searchParams.get('isMobile') === '1' || searchParams.get('isMobile') === 'true';
  const halfWidthImageClass = `${isMobile ? 'w-full' : 'w-1/2'} h-auto`;
  const imageGridClass = `w-full grid ${isMobile ? 'grid-cols-1 gap-5' : 'grid-cols-2 gap-[30px]'}`;

  return (
    <div className="w-full bg-white min-h-screen flex flex-col">
      {!isMobile && <Header />}

      <div className="w-full bg-white inline-flex justify-center overflow-hidden">
        <div className="container pt-10 pb-20 px-4 md:px-0 flex flex-col justify-start items-start gap-[60px]">
          <div className="w-full flex flex-col justify-start items-start gap-2.5">
            <div className="text-black text-[40px] font-bold leading-[60px]">クオリティガイドライン - 未開封パック</div>
            <div className="h-[3px] w-full bg-[#e4e4e4]" />
          </div>

          <div className="self-stretch flex flex-col justify-start items-start gap-[30px]">
            <div className="px-[5px] inline-flex justify-start items-center gap-2.5">
              <div className="w-0 h-[27.50px] border-[#e4e4e4] border-2 rounded-xl" />
              <div className="text-black text-2xl font-bold leading-9">出品条件</div>
            </div>
            <div className="w-full text-black text-base leading-7">
              出品の対象となるのは、以下のすべての条件を満たしている商品に限られます。<br />
              いずれか一つでも該当しない場合は、出品いただくことはできません。<br />
              ・未使用、未開封であること<br />
              ・商品本体に汚れや破損がないこと<br />
              <br />
              また、販売経路を問わず出品を許可しているため、以下のような状態の商品についても出品が可能です。<br />
              ・パックに販売元の保証印が押されている<br />
              ・商品にバーコード（タグ）が直接貼付されている<br />
              ※販売店が貼付したと考えられるバーコード・タグに限ります
            </div>
          </div>

          <div className="self-stretch flex flex-col justify-start items-start gap-[30px]">
            <div className="px-[5px] inline-flex justify-start items-center gap-2.5">
              <div className="w-0 h-[27.50px] border-[#e4e4e4] border-2 rounded-xl" />
              <div className="text-black text-2xl font-bold leading-9">注意事項</div>
            </div>
            <div className="flex flex-col justify-start items-start gap-2.5">
              <div className="w-full text-black text-base leading-7">
                ・ガイドラインに記載されている内容はあくまで一例であり、商品ごとに状態レベルの基準が変動する場合があります。<br />
                ・掲載されている商品画像は、撮影環境などの影響により、実物と色味が異なって見えることがあります。<br />
                ・商品の検品時には、選択された商品状態がガイドラインの基準と一致しているかを確認しております。<br />
                ・補足説明に記載された内容よりも、ガイドラインで定められた基準が優先されます。<br />
                ※なお、商品状態にかかわらず、購入者様に誤解を与えるような表現や、出品情報と大きく異なる内容が記載されている場合は、取引がキャンセルとなる可能性があります。
              </div>
              <div className="flex flex-col justify-start items-start">
                <div className="w-full text-black text-base leading-7">すべての出品に共通するルールや、出品情報に関する詳細については、以下のページもあわせて必ずご確認ください。</div>
                <Link
                  to={`/terms/guideline_listing${location.search}`}
                  className="w-full text-[#00b8f9] text-base underline leading-7 hover:text-[#0099d6]"
                >
                  出品ガイドライン
                </Link>
              </div>
            </div>
          </div>

          <div className="self-stretch flex flex-col justify-start items-start gap-[30px]">
            <div className="px-[5px] inline-flex justify-start items-center gap-2.5">
              <div className="w-0 h-[27.50px] border-[#e4e4e4] border-2 rounded-xl" />
              <div className="text-black text-2xl font-bold leading-9">商品の状態</div>
            </div>
            <div className="flex flex-col justify-start items-start gap-5 w-full">
              <div className="flex flex-col justify-center items-start gap-2.5 w-full">
                <div className="text-black text-base font-bold leading-7">・圧着部の剥がれ</div>
                <div className="text-black text-base leading-7 w-full">
                  圧着部に軽微な剥がれが見られる個体がございます。<br />
                  製造・販売の過程や環境によって発生し、正規店で購入された商品にも見られる状態については、ガイドライン基準を満たすものといたします。<br />
                  一方で、正規販売店での商品取扱い（陳列・販売・梱包など）の過程では発生し得ない大きな圧着部の剥がれが見られる商品については、ガイドライン基準を満たしていないと判断いたします。
                </div>
                <img
                  className={halfWidthImageClass}
                  src="/images/terms/guideline_unopened_pack_01.jpg"
                  alt="圧着部の軽微な剥がれの例"
                />
              </div>

              <div className="flex flex-col justify-center items-start gap-2.5 w-full">
                <div className="text-black text-base font-bold leading-7">・切り取り痕</div>
                <div className="text-black text-base leading-7 w-full">
                  正規店においては、販売時にパックの一部を切り取る方法が採用されている場合があります。<br />
                  そのため、中身に影響のない範囲での切り取り痕については、ガイドライン基準を満たすものと判断いたします。
                </div>
                <img
                  className={halfWidthImageClass}
                  src="/images/terms/guideline_unopened_pack_02.jpg"
                  alt="切り取り痕の例"
                />
              </div>

              <div className="flex flex-col justify-center items-start gap-2.5 w-full">
                <div className="text-black text-base font-bold leading-7">・傷、製造痕、汚損</div>
                <div className="text-black text-base leading-7 w-full">
                  製造過程や正規店での商品取扱い（陳列・販売・梱包など）の際に発生し得る軽微な傷や製造痕については、ガイドライン基準を満たすものといたします。<br />
                  一方で、上記の過程では発生し得ない大きな傷や汚損が確認された場合は、ガイドライン基準を満たしていないと判断いたします。
                </div>
                <div className={imageGridClass}>
                  <img
                    className="w-full h-auto"
                    src="/images/terms/guideline_unopened_pack_03.jpg"
                    alt="軽微な傷の例"
                  />
                  <img
                    className="w-full h-auto"
                    src="/images/terms/guideline_unopened_pack_04.jpg"
                    alt="傷が基準を満たしていない例"
                  />
                </div>
              </div>

              <div className="flex flex-col justify-center items-start gap-2.5 w-full">
                <div className="text-black text-base font-bold leading-7">・裂け</div>
                <div className="text-black text-base leading-7 w-full">
                  空気穴（製造時に生じるもの）とは異なる大きな穴や、パックが大きく裂けている商品については、ガイドライン基準を満たしていないと判断いたします。
                </div>
                <img
                  className={halfWidthImageClass}
                  src="/images/terms/guideline_unopened_pack_05.jpg"
                  alt="裂けが確認できる商品"
                />
              </div>

              <div className="flex flex-col justify-center items-start gap-2.5 w-full">
                <div className="text-black text-base font-bold leading-7">・開封されている</div>
                <div className="text-black text-base leading-7 w-full">
                  開封の痕跡がある商品や、袋に一部でも破れが生じている商品は、中身（カード）のすり替えが可能であるため、ガイドライン基準を満たしていないと判断いたします。
                </div>
                <img
                  className={halfWidthImageClass}
                  src="/images/terms/guideline_unopened_pack_06.jpg"
                  alt="開封痕がある商品の例"
                />
              </div>
            </div>
          </div>

          <TermGuidelineCategory />
        </div>
      </div>

      {!isMobile && <Footer />}
    </div>
  );
};

export default QualityGuidelineUnopenedPackPage;
